<planthunter-amountofnewhunts-component></planthunter-amountofnewhunts-component>